import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  CreatePostRequest,
  DeletePostRequest,
  SearchPostsRequest,
  UpdatePostRequest,
  ViewPostHierarchyRequest,
  ViewPostsRequest
} from './post.types';

import {
  requestCreatePost,
  requestDeletePost,
  requestSearchPosts,
  requestUpdatePost,
  requestViewPostHierarchy,
  requestViewPosts
} from './post.actions';

export const usePostApi = () => {
  const dispatch = useDispatch();

  const createPost = useCallback(
    (requestData: CreatePostRequest, onSuccess?: () => void) => {
      dispatch(requestCreatePost({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewPosts = useCallback(
    (requestData: ViewPostsRequest, onSuccess?: () => void) => {
      dispatch(requestViewPosts({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updatePost = useCallback(
    (requestData: UpdatePostRequest, onSuccess?: () => void) => {
      dispatch(requestUpdatePost({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const deletePost = useCallback(
    (requestData: DeletePostRequest, onSuccess?: () => void) => {
      dispatch(requestDeletePost({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const searchPosts = useCallback(
    (requestData: SearchPostsRequest, onSuccess?: () => void) => {
      dispatch(requestSearchPosts({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewPostHierarchy = useCallback(
    (requestData: ViewPostHierarchyRequest, onSuccess?: () => void) => {
      dispatch(requestViewPostHierarchy({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { createPost, viewPosts, updatePost, deletePost, searchPosts, viewPostHierarchy };
};
